function AccountCtrl($scope, $state, authService) {
  $scope.logout = function ($event) {
    if ($event) $event.preventDefault();

    authService.logout();

    $state.go('login');
  };
}

AccountCtrl.$inject = [
  '$scope',
  '$state',
  'authService'
];

export default AccountCtrl;



// WEBPACK FOOTER //
// ./src/components/account/accountCtrl.js